import React from 'react';
import { arrayOf, bool, element, func, number, object, shape, string } from 'prop-types';
import { styled } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import SovosFile from '../../sovos-file';
const Root = styled('li')(_ref => {
  let {
    theme: {
      palette,
      shape: themeShape,
      spacing
    }
  } = _ref;
  return {
    border: "1px solid ".concat(palette.divider),
    borderRadius: themeShape.borderRadiusSmall,
    marginBlock: spacing(),
    overflow: 'hidden',
    padding: 0,
    position: 'relative'
  };
});
const Progress = styled(LinearProgress)(_ref2 => {
  let {
    theme: {
      spacing
    }
  } = _ref2;
  return {
    height: spacing(0.5),
    insetBlockEnd: 0,
    position: 'absolute',
    width: '100%'
  };
});
const FileUploadItem = _ref3 => {
  var _fileInfo$progress;
  let {
    actionMenuItems,
    confirmDelete = false,
    disabled = false,
    FileDeleteConfirmationProps,
    fileInfo,
    onFileClick,
    onFileDelete
  } = _ref3;
  return /*#__PURE__*/React.createElement(Root, null, /*#__PURE__*/React.createElement(SovosFile, {
    actionMenuItems: actionMenuItems,
    confirmDelete: confirmDelete,
    disabled: disabled,
    FileDeleteConfirmationProps: FileDeleteConfirmationProps,
    fileInfo: fileInfo,
    onClick: onFileClick,
    onDelete: onFileDelete
  }), ((_fileInfo$progress = fileInfo.progress) === null || _fileInfo$progress === void 0 ? void 0 : _fileInfo$progress.loading) && /*#__PURE__*/React.createElement(Progress, {
    "aria-busy": fileInfo.progress.loading,
    color: "primary",
    variant: fileInfo.progress.percent != null ? 'determinate' : undefined // eslint-disable-line
    ,
    value: fileInfo.progress.loading ? fileInfo.progress.percent : undefined
  }));
};
FileUploadItem.propTypes = {
  actionMenuItems: arrayOf(element),
  confirmDelete: bool,
  disabled: bool,
  FileDeleteConfirmationProps: object,
  fileInfo: shape({
    name: string,
    bytes: number,
    progress: shape({
      loading: bool,
      percent: number
    }),
    uploadedDate: string,
    uploadedBy: string
  }).isRequired,
  onFileClick: func,
  onFileDelete: func
};
export default FileUploadItem;